import { useGetOrganizationId } from './useGetOrganizationId';
import { useGetOrganizationPackagesQuery } from '@/redux/slices/packageApiSlice';

/**
 * Hook to determine if the current organization is a multi plan organization.
 * @returns {boolean} True if the organization has more than one package, false otherwise.
 */
export const useIsMultiPlanOrganization = (): boolean => {
  const organizationId = useGetOrganizationId();
  const { data: organizationPackagesData } =
    useGetOrganizationPackagesQuery(organizationId);
  return (organizationPackagesData?.length ?? 0) > 1;
};
